import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
    captchaEnabled: true
}

export {
  state,
  getters,
  mutations,
  actions
}
  